<template>
    <ContainerContent
        class="mb-8"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Manage Email Preferences</h1>
            </v-col>
        </v-row>
        <v-row v-if="uid">
            <v-col>
                <SubscriptionsList
                    :uid="uid"
                    :pre-selected="preSelected"
                ></SubscriptionsList>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
                <v-alert
                    color="error"
                    :icon="mdiAlertCircle"
                    title="Subscriptions Not Found"
                    text="Unable to find your subscriptions."
                ></v-alert>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import SubscriptionsList from '~/components/subscriptions/SubscriptionsList/SubscriptionsList.vue';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import { mdiAlertCircle } from '@mdi/js';

    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    useHead({
        title: `Manage Email Preferences | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Manage Email Preferences'
            }
        ]
    });

    const route = useRoute();
    const uid = getSingleParam(route.query, 'uid');
    const preSelected = getSingleParam(route.query, 'email_type');
</script>
